import React, { useState } from 'react'
import styled, { keyframes } from 'styled-components'
import Nex1 from '../media/Nex1.png'
import Nex2 from '../media/Nex2.png'
import Nex3 from '../media/Nex3.gif'
import { useSelector } from 'react-redux'
import { base } from '../utils'


function Store() {
    const [sUnits, setSUnits] = useState(1)
    const [bUnits, setBUnits] = useState(1)

    const [showSoon, setShowSoon] = useState(false)

    const user = useSelector(state=> state.user.user)


    const orderUnits = () => {
        if(sUnits !== 0) {
            fetch(`${base}/payment`, {
                method: 'POST',
                headers: {
                        'Content-Type': 'application/json'
                        },
                body: JSON.stringify({
                    material: {
                        name: 'nexilum_unit',
                        q: sUnits
                    },
                    userId: user.id
                })
            }).then(res=> res.json()).then(data=> window.location.href = data.approvalUrl)
        }
    }



    const orderBottls = () => {
        if(bUnits !== 0) {
            fetch(`${base}/payment`, {
                method: 'POST',
                headers: {
                        'Content-Type': 'application/json'
                        },
                body: JSON.stringify({
                    material: {
                        name: 'nexilum_bottle',
                        q: bUnits
                    },
                    userId: user.id
                })
            }).then(res=> res.json()).then(data=> window.location.href = data.approvalUrl)
        }
    }



  return (
    <StoreContainer>
        <h1 style={{color: '#DE2699'}}>Nexilum</h1>
        <ItemsContainer>
            <Card>
                <img src={Nex1} />
                <h2>Nexilum Unit</h2>
                <p>Unlock <span className='dur'></span> the power of Market Lab's advanced tools with a single dose of <span style={{color: '#DE2699'}}>Nexilum</span>. 
                    Dive into data-driven insights with this potent elixir of scientific innovation
                </p>
                
                <div>
                    <label for="quantity">Nexilum Units:</label>
                    <input type="number" id="quantity" name="quantity" min="1" max="200" step="1" value={sUnits} onChange={e=> setSUnits(e.target.value > 200? 200: e.target.value)}/>
                    {/* <p>{sUnits} Nexilum {sUnits > 1? 'units': 'unit'}</p> */}
                    <button onClick={orderUnits}>(${(sUnits * 0.20).toFixed(2)}) Buy</button>
                </div>
            </Card>
            <Card style={{width: '400px'}}>
                <img src={Nex2} />
                <h2>Nexilum Bottle</h2>
                <p>Dive into a world of possibilities with just one vial of <span style={{color: '#DE2699'}}>Nexilum</span>. Experience <span className='dur'></span>the might of Market Lab's unparalleled insights, where data meets discovery in a concoction of pure scientific marvel
                </p>
                
                <div>
                    <label for="quantity">Bottles:</label>
                    <input type="number" id="quantity" name="quantity" min="1" max="20" step="1" value={bUnits} onChange={e=> setBUnits(e.target.value > 20? 20: e.target.value)}/>
                    <p>{bUnits * 10} Nexilum units</p>
                    <button onClick={orderBottls}>(${bUnits * 2}) Buy</button>
                </div>
            </Card>
            <Card style={{position: 'relative'}}>
                <img src={Nex3} />
                <h2>Free Nexilum Units</h2>
                <p>Watch an ad and receive a complimentary 3 units of <span style={{color: '#DE2699'}}>Nexilum</span>. Each unit grants access to Market Lab's advanced tools and analytics
                </p>
                
                <div>
                    <label for="quantity">3 units per ad</label>
                    <button onMouseEnter={()=> setShowSoon(true)} onMouseLeave={()=> setShowSoon(false)} style={{cursor: 'default'}}>Watch Ad</button>
                    {showSoon && <CS style={{position: 'absolute'}}>
                        <p>Our ad option is not available currently, but it's coming soon. Stay tuned for updates!</p>
                    </CS>}
                </div>
            </Card>
        </ItemsContainer>
        <WhatIsNex onClick={()=> {{window.location.href = '/what-is-nexilum'}}}>What is Nexilum ?!</WhatIsNex>
    </StoreContainer>
  )
}

export default Store


const StoreContainer = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #f5f5f5;
    width: 100%;
    max-width: 1200px;
    z-index: 1000;

    > h1 {
        font-weight: 300;
        margin-block: 20px;
        margin-left: 30px;
    }

    > p {
        margin-left: 15px;
        margin-top: 10px;
        cursor: pointer;
        transition: color 0.3s ease-in-out;

        &:hover {
            color: gray;
        }
    }
`

const fadeEffect = keyframes`
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
`


const ItemsContainer = styled.div`
    display: flex;
    flex-direction: row;
    padding: 20px 30px;
    gap: 35px;
    justify-content: space-around;
    align-items: center;
`

const textColor = keyframes`
    0% {
        color: dodgerblue;
    }

    25% {
        color: purple;
    }

    55% {
        color: gold;
    }

    68% {
        color: var(--tst-color);
    }

    79% {
        color: var(--cntnt-color);
    }

    100% {
        color: dodgerblue;
    }
`

const Card = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 10px;
    word-wrap: break-word;
    width: 360px;
    height: 460px;

    > img {
        width: 200px;

        opacity: 0;
        animation: ${fadeEffect} 1s ease-in-out forwards;
    }

    > h2 {
        font-weight: 300;
    }

    > p {
        margin-top: 20px;
        height: 110px;
    }

    > p > .dur {
        animation: ${textColor} 10s ease-in-out infinite;
    }

    > div {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 15px;
        width: 100%;
        margin-top: 20px;

        > p {
            font-size: small;
        }

        > label {
            font-size: small;
        }
    }

    > div > button {
        padding: 5px 10px;
        border: 1px solid #DE2699;
        border-radius: 5px;
        background-color: #DE2699;
        color: white;
        cursor: pointer;
        width: 100px;
        justify-self: left;
        font-size: small;

        &:hover {
            background-color: white;
            color: #DE2699;
            border: 1px solid lightgray;
        }
    }

    > div > input {
        height: 20px;
    }
`


const WhatIsNex = styled.div`
    width: fit-content;
    padding: 5px 10px;
    background-color: #de2699;
    color: white;
    cursor: pointer;
    margin-left: 15px;
    margin-top: 10px;
    transition: background-color 0.3s ease-in-out;

    &:hover {
        background-color: darkmagenta;
        color: white;
    }
`


const CS = styled.div`
    display: flex;
    bottom: 70px;
    right: 20px;
    background-color: white;
    border: 1px solid gray;
    border-radius: 3px;
    width: 400px;
    padding: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);

    opacity: 0;
    animation: ${fadeEffect} 0.3s ease-in-out forwards;
`